export default __webpack_public_path__ + "static/media/train.7f34e950.png";